import {
    ChangeDetectionStrategy,
    Component,
    Input,
} from '@angular/core';
import { LicenseConsumerType } from '@models';

@Component({
    selector: 'ui-license-usage-subtitle',
    templateUrl: './ui-license-usage-subtitle.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UiLicenseUsageSubtitleComponent {
    @Input()
    public consumerType!: LicenseConsumerType;

    @Input()
    public used!: number;

    @Input()
    public available!: number;

    public licenseConsumerType = LicenseConsumerType;
}
